const checkAuthenticated = async (to, from, next) => {
  if (localStorage.getItem('authDetails') === null) {
    return next('/auth/login');
  } else {
    return next();
  }
};

export default checkAuthenticated;
